import { useEffect, useState } from "react";
import { ConditionRowFilter } from "@/frontend/components/FilterV2/model/types";
import { compressFilter, decompressFilter } from "./filtersEncoding";

function getFiltersFromLocalStorage(key: string, pipelineId: string | null): ConditionRowFilter[] {
  if (!pipelineId) return [];

  const serializedFilters = localStorage.getItem(key);
  if (serializedFilters) {
    const obj = JSON.parse(serializedFilters);
    if (obj?.[pipelineId]) {
      return obj[pipelineId].map(decompressFilter).filter((f: any) => !!f);
    }
  }
  return [];
}

export function usePipelineFilters(key: string, pipelineId: string | null) {
  const [filters, setFilters] = useState<ConditionRowFilter[]>(getFiltersFromLocalStorage(key, pipelineId));

  useEffect(() => {
    setFilters(getFiltersFromLocalStorage(key, pipelineId));
  }, [key, pipelineId]);

  useEffect(() => {
    if (!pipelineId) return;
    const serializedFilters = filters.map(compressFilter).filter((filter) => filter !== null) as string[];
    const oldFiltersAll = JSON.parse(localStorage.getItem(key) || "{}");
    const newFiltersAll = {
      ...oldFiltersAll,
      [pipelineId]: serializedFilters
    };

    localStorage.setItem(key, JSON.stringify(newFiltersAll));
  }, [filters, pipelineId]);

  return { filters, setFilters };
}
